import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from './api-base.service';
import ApiOptionsConfig from './api-options.config';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const BASE_URL = '/complaints';

@Injectable({
  providedIn: 'root'
})
export class ComplaintsService extends ApiBaseService {

  constructor() {
    super();
  }

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(complaintId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${complaintId}`), options?.params);
  }

  create(data: any): Observable<any> {
   return this.POST(this.getUrl(BASE_URL), data);
  }

  update(complaintId: number, data: any): Observable<any> {
  return this.PUT(this.getUrl(`${BASE_URL}/${complaintId}`), data);
  }

  delete(complaintId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${complaintId}`));
  }

  countersStatus(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/status-counters`), options?.params);
  }

  attachmentsComplaintList(complaintId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${complaintId}/attachments`), options?.params);
  }

  attachmentsComplaintCreate(complaintId: number, formData: FormData): Observable<any> {
    return this.POSTMULTIPART(this.getUrl(`${BASE_URL}/${complaintId}/attachments`), formData);
  }

  attachmentsComplaintDelete(complaintId: number, attachmentId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${complaintId}/attachments/${attachmentId}`));
  }

  speechComplaintList(complaintId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${complaintId}/messages`), options?.params);
  }

  speechComplaintCreate(complaintId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${complaintId}/messages`), data);
  }

  speechComplaintUpdate(complaintId: number, complaintMessageId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${complaintId}/messages/${complaintMessageId}`), data);
  }

  speechComplaintDetail(complaintId: number, complaintMessageId: number): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${complaintId}/messages/${complaintMessageId}`));
  }

  speechComplaintDelete(complaintId: number, complaintMessageId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${complaintId}/messages/${complaintMessageId}`));
  }


  listNotes(complaintId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${complaintId}/notes`), options?.params);
  }

  createNotes(complaintId: number, data: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${complaintId}/notes`), data);
  }

  deleteNotes(complaintId: number, noteId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${complaintId}/notes/${noteId}`));
  }

  closedComplaint(complaintId: number, data?: any): Observable<any> {
    return this.POST(this.getUrl(`${BASE_URL}/${complaintId}/close`), data || {});
  }

  optionsCategories(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`/complaint-categories`), options?.params);
  }

  override getUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`;
  }
}
